export default __webpack_public_path__ + "assets/images/ins.5c4ba05.png";